export const customMatIconsData: { label: string; url: string }[] = [
    { label: 'carrying-boxes', url: 'assets/custom-mat-icons/carrying-boxes.svg' },
    { label: 'loaded-truck', url: 'assets/custom-mat-icons/loaded-truck.svg' },
    { label: 'box', url: 'assets/custom-mat-icons/box.svg' },
];
